import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ACTIVITIES_NAV_COUNT_KEY, fetchActivitiesOwnOpenCount } from '@/lib/activities-own-open-count';
import { useNavCountRefreshTick, usePublishNavCount } from '@/lib/nav-counts';

/** The Aktivitäten badge's one owner (IMM-1360.4, D3): read on entry, on every page change, on focus, and on request. */
export function ActivitiesNavCount({ workspaceId }: { readonly workspaceId: string }): null {
  const { pathname } = useLocation();
  const refreshTick = useNavCountRefreshTick(ACTIVITIES_NAV_COUNT_KEY);
  const [focusTick, setFocusTick] = useState(0);
  const [count, setCount] = useState<number | undefined>(undefined);
  const request = useRef(0);
  const reported = useRef(new Set<string>());

  useEffect(() => {
    const onFocus = () => setFocusTick((tick) => tick + 1);
    window.addEventListener('focus', onFocus);

    return () => window.removeEventListener('focus', onFocus);
  }, []);

  useEffect(() => {
    request.current += 1;
    const issued = request.current;

    // The last good number stays until this answer lands; a newer request's answer wins.
    void fetchActivitiesOwnOpenCount(workspaceId, reported.current).then((next) => {
      if (request.current === issued) setCount(next);
    });
  }, [workspaceId, pathname, focusTick, refreshTick]);

  usePublishNavCount(ACTIVITIES_NAV_COUNT_KEY, count);

  return null;
}
